export default __webpack_public_path__ + "static/media/help-desk-5.d6a0bd11.png";